import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import BgImg from "images/png/landing-page/getStartedContainerBg.png";
import HandPoint from "images/png/landing-page/handPoint.png";

const GetStarted = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <BGContainer>
        <Typography
          size="4.8rem"
          m_size="4xl"
          align="center"
          weight="semibold"
          mb="4"
        >
          Start Distributing Your Music With <br /> Rated Afrika Today!
        </Typography>
        <PrimaryButton
          text="Get Started"
          fitContent
          inset
          sparkle
          onClick={() => navigate("/create-account")}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M3.33398 10H16.6673M16.6673 10L11.6673 5M16.6673 10L11.6673 15"
                stroke="#131313"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          iconSize="2"
          iconPosition="right"
        />
        <HandPointContainer src={HandPoint} alt="hand-point" />
      </BGContainer>
    </Container>
  );
};

export default GetStarted;

const Container = styled.div`
  padding-bottom: 9rem;
`;

const BGContainer = styled.div`
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  height: 55rem;
  border-radius: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-image: url(${BgImg});
  background-position: center center;
  background-size: 100%;
  background-color: #131313;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 90%;
    height: 35rem;
  }
`;

const HandPointContainer = styled.img`
  position: absolute;
  width: 36rem;
  bottom: 0;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
